
import { RoutesMixin, TranslationMixin } from '~/mixins'

export default {
  name: 'SectionContentStriped',
  mixins: [RoutesMixin, TranslationMixin],
  props: {
    item: {
      type: Object,
      required: true,
      project_short_descriptions: {
        type: Array,
        required: true,
        image: {
          type: Object,
          filename_disk: {
            type: String,
            required: true
          }
        },
        project_id: {
          type: Object,
          required: true,
          translations: {
            type: Array,
            required: true
          }
        },
        translations: {
          type: Array,
          required: true
        }
      }
    }
  },
  data() {
    return {
      projectShortDescriptionList: []
    }
  },
  created() {
    this.projectShortDescriptionList = this.generateProjectShortDescriptionList()
  },
  methods: {
    generateProjectShortDescriptionList() {
      let list = []
      this.item.project_short_descriptions.forEach(project_short_description => {
        const translation = this.translation(project_short_description)
        list.push({
          headline: translation.headline,
          description: translation.description,
          projectPath: this.pathForPage(project_short_description.project_id.page),
          image: project_short_description.image,
          project_id: project_short_description.project_id
        })
      })
      return list
    },
    translation(item) {
      return this.getTranslation(item.translations)
    }
  }
}
